const LOOKER_BLUEPRINT_NAME = "looker";

export const isLookerBlueprint = (name: string): boolean => {
  return name === LOOKER_BLUEPRINT_NAME;
};

export type DataSourceType = "dashboard" | "look";

export type DatasourceConfig = {
  connectionId: string;
  type: DataSourceType;
  dashboardId?: string;
  tileId?: string;
  lookId?: string;
};

export interface ILookerConnectionData {
  id: string;
  name: string;
}

export interface ILookerBuildInsightContext {
  connections: ILookerConnectionData[];
  blueprintName: string;
}

export interface ILookerEntity {
  id: number;
  title: string;
}

export type DatasourceEntityConfig = {
  key: string;
  name: string;
  defaultEntityName: string;
};
